<template>
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/newImges/icons/close-icon.svg"
        alt="close-modal-img"
      />
    </div>
    <div id="forgot-password">
      <div class="form" v-if="!tokenString">
        <div v-if="isEmailSent">
          <h3>
            {{ $t("resetPass.checkEmail") }}
            <img src="@/assets/newImges/icons/check-email.svg" alt="" />
          </h3>
          <p>{{ $t("resetPass.linkSentTxt") }}</p>
        </div>
        <div v-else>
          <h3>{{ translations.resetPassword }}</h3>
          <p>{{ $t("resetPass.resetLinkArrive") }}</p>
          <TestInput
            v-model="email"
            :label="translations.email"
            @keydown.enter="sendEmail"
            type="text"
          />
          <button
            class="btn dark-blue"
            @click="sendEmail"
            :class="{ disabled: !email }"
            :disabled="!email"
          >
            {{ translations.buttonName }}
          </button>
        </div>
      </div>
      <template v-if="tokenString">
        <div class="change" v-if="!isTokenDone">
          <div class="form">
            <h3>{{ $t("resetPass.newPassword") }}</h3>
            <p>{{ $t("resetPass.newPasswordTxt") }}</p>
            <TestInput
              v-model="newPassword"
              :label="translations.password"
              type="password"
              ref="newPass"
            />
            <TestInput
              v-model="newPasswordConfirm"
              :label="translations.confirmPassword"
              @keydown.enter="sendPassword"
              type="password"
            />
            <button
              class="btn dark-blue"
              @click="sendPassword"
              :class="{ disabled: !isValidPassword }"
            >
              {{ $t("resetPass.setPass") }}
            </button>
          </div>
        </div>
        <div class="message" v-if="isTokenDone">
          <div class="form">
            <h3 style="margin-bottom: 60px;">{{ formText.success }}.</h3>
            <div class="btn dark-blue" @click="openSignInModal">
              {{ $t("resetPass.login") }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import TestInput from "@/components/shared/testInput.vue";
import eventBus from "@/shared/eventBus.js";

export default {
  data() {
    return {
      email: "",
      newPassword: "",
      newPasswordConfirm: "",
      isTokenDone: false,
      isEmailSent: false
    };
  },
  components: {
    TestInput
  },
  computed: {
    tokenString() {
      return this.$route.query.token;
    },
    formText() {
      return {
        success: this.$i18n.t("main.passwordResetSuccess"),
        error: this.$i18n.t("main.msgError")
      };
    },
    isValidPassword() {
      const isValidSize =
        this.newPassword.length > 7 && this.newPassword.length < 33;
      const isSame = this.newPassword === this.newPasswordConfirm;
      return isValidSize && isSame;
    },
    translations() {
      return {
        email: this.$i18n.t("main.email"),
        buttonName: this.$i18n.t("main.sendResetLink"), //  this.$i18n.t("main.submit"),
        resetPassword: this.$i18n.t("main.resetPassword"),
        password: this.$i18n.t("main.password"),
        confirmPassword: this.$i18n.t("main.confirmPassword")
      };
    }
  },
  mounted() {
    if (this.tokenString) {
      this.checkValidToken();
      this.$refs.newPass.focus();
    }
  },
  methods: {
    async sendEmail() {
      if (!this.email) {
        return;
      }
      const params = {
        usr_email: this.email
      };
      try {
        const res = await api.forgotPassword(params);
        console.log("forgot password response:", res.data);
        this.isEmailSent = true;
        // this.$toast.success(this.$t("main.msgSuccess"), {
        //   duration: 3000
        // });
        // this.$router.push({
        //   name: "Home"
        // });
      } catch (err) {
        this.$toast.error(this.$t("main.msgError"), {
          duration: 5000
        });
        console.log(err.message);
      } finally {
        this.email = "";
      }
    },
    async checkValidToken() {
      const params = {
        token: this.tokenString
      };
      try {
        await api.checkForgotPassword(params);
      } catch (err) {
        this.$toast.error(this.$t("errors.registration.invalidToken"), {
          duration: 5000
        });
        this.$router.push({
          name: "Home"
        });
        console.log(err.message);
      }
    },
    async sendPassword() {
      if (!(this.newPassword.length > 7 && this.newPassword.length < 33)) {
        this.$toast.error(this.$t("errors.registration.password"), {
          duration: 5000
        });
        return;
      }
      if (this.newPassword !== this.newPasswordConfirm) {
        this.$toast.error(this.$t("errors.registration.samePasswords"), {
          duration: 5000
        });
        return;
      }

      const params = {
        token: this.tokenString,
        password: this.newPassword
      };
      try {
        await api.patchForgotPassword(params);
        this.isTokenDone = true;
      } catch (err) {
        this.$toast.error(this.$t("main.msgError"), {
          duration: 5000
        });
        console.log(err.message);
      } finally {
        this.newPassword = "";
        this.newPasswordConfirm = "";
      }
    },
    closeModal() {
      eventBus.$emit("closeModal");
      this.$router.push({
        name: "Home"
      });
    },
    openSignInModal() {
      let params = {
        modalData: { userIsLoged: this.userIsLoged },
        component: "signInMod"
      };
      eventBus.$emit("openModal", params);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  font-family: Outfit;
  box-sizing: border-box;
  width: 777px;
  max-width: 80%;
  min-height: 300px;
  max-height: 80vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";
  padding: 40px !important;

  .modal-close {
    display: flex;
    justify-content: flex-end;

    img {
      width: 20px;
      cursor: pointer;
    }
  }
}
#forgot-password {
  text-align: left;
  // box-sizing: border-box;
  // width: 777px;
  // max-width: 80%;
  // height: 811px;
  // max-height: 80vh;
  // overflow: auto;
  // @import "@/assets/scss/scrollbarStyles.scss";
  // @include scrollbar;
  // @import "@/assets/scss/cardStyles.scss";
  // padding: 40px !important;
  // background-color: $gray-100;

  h3 {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    line-height: 100%;
    letter-spacing: 0%;
    color: $blue-1000;
    margin: 0;
    margin-bottom: 30px;
  }
  p {
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0%;
    margin: 0;
    margin-bottom: 30px;
  }

  .form {
    // border: 1px solid silver;
    padding: 30px 25px;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // gap: 20px 10px;

    .input-wrapper {
      margin-bottom: 30px;
    }

    .btn {
      // background: #e9786e;
      // text-transform: uppercase;
      // color: white;
      // width: calc(50% - 7px);
      // font-weight: bold;
      // font-size: 10px;
      // text-transform: none;
      width: 100%;
      &.disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }
    }
  }
}
</style>
